import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCampaignWidgets } from 'api/widgets';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { widgetQueryKeys } from 'queries/widget-query-keys';
import { Widget } from 'types/domain';

const useCampaignWidgets = (campaignId?: number) => {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery({
        queryKey: widgetQueryKeys.widgetsByCampaignId(accountId, campaignId!),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchCampaignWidgets(accountId, campaignId!),
                !!campaignId,
            ),
        select: data => data ?? ([] as Widget[]),
    });
};

export { useCampaignWidgets };
